// Components
import Box from "@mui/material/Box";

type GradientHeaderType = {
  header: string;
};

const GradientHeader = ({ header }: GradientHeaderType) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        background:
          "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
        color: "#FFF",
        fontSize: "16px",
        fontWeight: 600,
        borderRadius: "8px",
        padding: "12px 20px",
      }}
    >
      {header}
    </Box>
  );
};

export default GradientHeader;
